import remoteObject from 'util/remoteObject';
const ro = new remoteObject('/RequestManager');

export default {
    getData: () => ro.get('getData'),

    submitContactForm: contact => ro.post('submitContactForm', contact),
};
